import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import "./A1IMGPopup.css";

const POPUP_HOST_SELECTOR =
  ".help-chat-box.chatIn-header.help-assistantwrapp.hbc0.maximize";
const CLOSE_POPUP_EVENT = "a1img-popup-close";

const A1IMGPopup = ({
  title,
  question,
  description,
  bannerUrl,
  bannerAlt,
  yesButton,
  noButton,
  disable,
  onAnswer,
}) => {
  const markerRef = useRef(null);
  const portalHostRef = useRef(null);
  const [portalTarget, setPortalTarget] = useState(null);

  useLayoutEffect(() => {
    const target =
      document.getElementById("top") ||
      markerRef.current?.closest(POPUP_HOST_SELECTOR) ||
      document.querySelector(POPUP_HOST_SELECTOR);

    if (!target) return undefined;

    portalHostRef.current = target;
    target.classList.add("a1img-popup-host");
    setPortalTarget(target);

    return () => {
      target.classList.remove("a1img-popup-host");
      if (portalHostRef.current === target) {
        portalHostRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    const closePopup = () => {
      const target = portalHostRef.current;
      target?.classList.remove("a1img-popup-host");
      setPortalTarget(null);
    };

    window.addEventListener(CLOSE_POPUP_EVENT, closePopup);
    return () => window.removeEventListener(CLOSE_POPUP_EVENT, closePopup);
  }, []);

  const handleAnswer = (button) => {
    ReactDOM.flushSync(() => {
      window.dispatchEvent(new Event(CLOSE_POPUP_EVENT));
    });
    onAnswer(button);
  };

  return (
    <>
      <span ref={markerRef} className="a1img-popup-marker" aria-hidden="true" />

      {portalTarget &&
        ReactDOM.createPortal(
          <div
            className="a1img-popup-overlay"
            role="dialog"
            aria-modal="true"
            aria-label={bannerAlt}
          >
            <div className="a1img-popup-card">
              <h2 className="a1img-popup-title">{title}</h2>

              {bannerUrl && (
                <div className="a1img-popup-visual">
                  <img
                    className="a1img-popup-banner"
                    src={bannerUrl}
                    alt={bannerAlt}
                  />
                </div>
              )}

              <div className="a1img-popup-copy">
                <h3 className="a1img-popup-question">{question}</h3>
                <p className="a1img-popup-description">{description}</p>
              </div>

              <div className="a1img-popup-actions">
                <button
                  type="button"
                  className="a1img-popup-button a1img-popup-button--yes action-tab"
                  disabled={disable}
                  onClick={() => handleAnswer(yesButton)}
                >
                  {yesButton.label}
                </button>
                <button
                  type="button"
                  className="a1img-popup-button a1img-popup-button--no action-tab"
                  disabled={disable}
                  onClick={() => handleAnswer(noButton)}
                >
                  {noButton.label}
                </button>
              </div>
            </div>
          </div>,
          portalTarget
        )}
    </>
  );
};

export default A1IMGPopup;
